"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompletePopup = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const Popper_1 = __importDefault(require("@material-ui/core/Popper"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const ClickAwayListener_1 = __importDefault(require("@material-ui/core/ClickAwayListener"));
const infinite_list_1 = require("../infinite-list/infinite-list");
const checkbox_1 = require("../checkbox/checkbox");
const autocomplate_styles_1 = require("./autocomplate-styles");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const autocomplete_context_1 = require("./autocomplete-context");
const autocomplete_item_1 = require("./autocomplete-item");
function AutocompletePopup({ autocompleteValue, setPopupOpen, invalidTextValue, setTextValue, anchorElRef, infiniteListRef, handleSelectItem, handleClear, }) {
    const classes = autocomplate_styles_1.useStyles();
    const { multiple, onChange, source, showTooltip, tooltipMapper, labelMapper = (option) => option.name, // fixme: memorize,
    ItemComponent = autocomplete_item_1.AutocompleteItem, } = react_1.useContext(autocomplete_context_1.AutocompleteContext);
    const handleClickAway = event_callback_hook_1.useEventCallback(() => {
        if (multiple) {
            setTextValue('');
        }
        setPopupOpen(false);
        if (invalidTextValue) {
            handleClear();
            onChange(null);
        }
    });
    return (react_1.default.createElement(Popper_1.default, { className: classes.popper, role: "presentation", anchorEl: anchorElRef.current, placement: "bottom-start", open: true, "data-cy": "EAS__AUTOCOMPLETE_MENU" },
        react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: handleClickAway },
            react_1.default.createElement(Paper_1.default, { className: classes.paper, square: true, elevation: 8 },
                react_1.default.createElement(infinite_list_1.InfiniteList, { ref: infiniteListRef, source: source, onItemClick: handleSelectItem, showTooltip: showTooltip, tooltipMapper: tooltipMapper, selectedIds: [], labelMapper: (item, index) => (react_1.default.createElement("div", { style: {
                            backgroundColor: index % 2 === 0 ? '#ededed55' : 'inherit',
                        }, className: classes.paperItem },
                        multiple && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(checkbox_1.Checkbox, { value: !!autocompleteValue
                                    .getMultipleIds()
                                    .find((id) => id === item.id), disabled: true, onChange: lodash_1.noop }),
                            react_1.default.createElement("div", { className: classes.delimiter }))),
                        react_1.default.createElement(ItemComponent, { item: item }, labelMapper(item, 'OPTION')))) })))));
}
exports.AutocompletePopup = AutocompletePopup;
//# sourceMappingURL=autocomplete-popup.js.map